<template>
  <div class="app-title-bar py-3 px-4 px-md-8 d-flex align-center justify-space-between"
       :class="{ 'app-title-bar--sticky': sticky }"
  >
    <div class="title d-flex align-center column-gap-2">
      <slot></slot>
    </div>
    <slot name="actions"></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { APP_HEADER_HEIGHT } from '@/common/constants'

export default defineComponent({
  name: 'AppTitleBar',
  props: {
    sticky: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      appHeaderHeight: `${APP_HEADER_HEIGHT}px`,
    }
  },
})
</script>

<style lang="scss">
  @import "@/scss/border-tokens";
  @import "@/scss/elevation-tokens";

  .app-title-bar {
    background-color: white;
    border-bottom: get-border();

    &--sticky {
      position: sticky;
      top: v-bind(appHeaderHeight);
      @include elevation('z-index-sticky');
    }
  }
</style>
